module.exports = __webpack_public_path__ + "media/images/logo-footer-6bbf5e18f8c72ccea9b8442909bd7bce.png";